import request from '@/util/bpmRequest'

/**
 * 分页查询委托
 */
export function pageQueryAll(data) {
  return request({
    url: '/delegation/task/pageQueryAll',
    method: 'post',
    data
  })
}

/**
 * 新增委托
 */
export function insert(data) {
  return request({
    url: '/delegation/task/insert',
    method: 'post',
    data
  })
}

/**
 * 删除委托
 */
export function entrustmentDelete(data) {
  return request({
    url: '/entrustment/delete',
    method: 'post',
    data
  })
}

/**
 * 批量取消委托
 */
export function cancellBatch(data) {
  return request({
    url: '/delegation/task/cancellBatch',
    method: 'post',
    data
  })
}

// 修改任务委托
export function revise(data) {
  return request({
    url: '/delegation/task/revise',
    method: 'post',
    data
  })
}